import type { FC } from 'react'

import type { SelectOption } from '@/components/Select'
import Select from '@/components/Select'

export enum Cifas {
  ALL = 'all',
  ONLY = 'only',
  NONE = 'none',
}

export type Filter = Cifas

const selectOptions: SelectOption<Cifas>[] = [
  {
    label: 'All',
    value: Cifas.ALL,
  },
  {
    label: 'Only',
    value: Cifas.ONLY,
  },
  {
    label: 'None',
    value: Cifas.NONE,
  },
]

export const DEFAULT_FILTER: Filter = Cifas.ALL

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const CifasFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <Select
    ariaLabel="CIFAS"
    selectedValue={filter}
    onSelect={onChangeFilter}
    options={selectOptions}
  />
)

export default CifasFilter
